import React, { useState } from "react";
import { connect } from "react-redux";
import Sidebar from "../../layout/Sidebar";
import Navbar from "../../layout/Navbar";
import Maincontent from "./Maincontent";

import { Layout, Breadcrumb } from "antd";
const { Content } = Layout;

const Sponsor = () => {
  const [updatelist, setUpdatelist] = useState(true);

  return (
    <>
      <Layout className="window-frame">
        <Sidebar />
        <Layout className="site-layout">
          <Navbar />
          <Content className="main-frame-content">
            <Breadcrumb style={{ margin: "16px 0" }}>
              <Breadcrumb.Item>Contact</Breadcrumb.Item>
              <Breadcrumb.Item>Sponsor</Breadcrumb.Item>
            </Breadcrumb>
            <Maincontent />
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default connect()(Sponsor);
